import { useEffect, useRef } from 'react'

import { sendGTMEvent } from '@b-stock/fe-core/bstock-next/components'
import {
  type OrchestratedOfferingListingDetails,
  type OrchestratedAuctionListingDetails,
  isAuctionListing,
} from '@b-stock/fe-core/bstock-next/queries'

import { getAppConfig } from '@/buyer-portal/config/appConfig'
import { orchestratedListingToGTMItemInput } from '@/helpers/telemetry/gtmItemAdapters'
import { getPersistedItemListContext } from '@/helpers/telemetry/itemListContext'
import { transformListingToGTMItem } from '@/helpers/telemetry/transformListingToGTMItem'

export const useListingDetailsLayoutTracking = ({
  listing,
}: {
  listing:
    | OrchestratedOfferingListingDetails
    | OrchestratedAuctionListingDetails
}) => {
  const hasTrackedViewItem = useRef(false)

  useEffect(() => {
    if (hasTrackedViewItem.current) return
    hasTrackedViewItem.current = true

    const { platform } = getAppConfig()
    const currentPrice = isAuctionListing(listing)
      ? listing.auction.winningBidAmount || listing.auction.startPrice || 0
      : listing.offering?.startOfferAmount || 0

    const { itemListId, itemListName } = getPersistedItemListContext(
      listing._id
    )
    const gtmItem = transformListingToGTMItem(
      orchestratedListingToGTMItemInput(listing),
      0,
      itemListId,
      itemListName
    )

    sendGTMEvent({ ecommerce: null })
    sendGTMEvent({
      event: 'view_item',
      platform,
      view_type: 'product_detail_page',
      ecommerce: {
        buying_format: listing.pricingStrategy.toLowerCase(),
        currency: 'USD',
        value: currentPrice,
        items: [gtmItem],
      },
    })
  }, [listing])
}
